var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"dropdown-container"},[_c('button',{staticClass:"dots-button",on:{"click":_vm.toggleDropdown}},[_vm._v(" ⋮ ")]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOpen),expression:"isOpen"}],ref:"popover",staticClass:"dropdown-menu",style:(_vm.dropdownPosition)},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }